export default __webpack_public_path__ + "static/media/cmk2020-ujk-logo.7a0494d7.png";